<div class="base-datos d-none d-md-none d-xl-block">
    <!-- <div class="container-fluid contenedor-video txBlanco">
        <div class="row">
            <div class="col-12 px-3 py-5 dis-flex mobile-p">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12 col-sm-10 col-lg-8 cuadro-video dis-flex">
                            <i *ngIf="config?.url_video && !startVideo" class="cursorPointer fas fa-play-circle" (click)="onStartViedeo()"></i>
                            <i *ngIf="!config?.url_video" class="cursorPointer fas fa-play-circle"></i>

                            <video *ngIf="config?.url_video && startVideo" width="100%" height="100%" autoplay="true" controls>
                                <source [src]='safeURL' type="video/mp4">
                            </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <!-- Definicion -->

    <div class="container-fluid py-5 definicion" id="baseutilidad">
        <div class="row">
            <div class="col-12">
                <div class="text-center titulo padding-b-25">
                    Definición
                </div>
                <div class="subtitulo padding-b-50 p-l">
                    - Base de Datos y utilidad -
                </div>
            </div>
            <div class=" offset-3 col-12 col-lg-6 p-l mobile-parrafo">
                <div>
                    La <span class="font-bold">Base de Datos</span> se refiere al conjunto de información perteneciente al <span class="font-bold">Programa de Resultados Electorales 
                    Preliminares</span>(PREP), ordenada de forma sistemática para su descarga y análisis.​ Es actualizada conforme al último corte. Permite realizar distintas operaciones ya que incluye datos numéricos, alfanuméricos y cronológicos.​
                </div>
            </div>
        </div>
    </div>

    <!-- Carpeta -->

    <div class="contenido container-fluid {{ !themeService.isDarkTheme() ? 'bgAzul txBlanco' : 'bgWhite'}} py-5" id="contenido">
        <div class="row justify-content-center">
            <div class="col-12">
                <div class="text-center titulo pading-b-10">
                    Carpeta de archivos
                </div>

            </div>
            <div class="col-12 col-xl-5 p-l">
                <div class="subtitulo padding-b-20">
                    - Contenido -
                </div>
                <div class="padding-b-30 mobile-parrafo">
                    Se trata de un archivo comprimido global con <br>
                    una nomenclatura que indica el <span class="font-bold">año</span>, <span class="font-bold">mes</span>, <br>
                    <span class="font-bold">día</span> y <span class="font-bold">hora del corte</span>; por ejemplo: <span class="font-bold">20240602_2100_PREP</span>, es de extensión <span class="font-bold">.zip</span><br>
                    y se encuentra organizado en carpetas <br>
                    por tipo de elección:
                </div>
                <div class="padding-b-30 mobile-parrafo">
                    <p *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="single-option"><i class="fas fa-circle"></i> 20240602_2100_PREP_GUB<span class="font-bold">.zip</span></p>
                    <!-- <p class="single-option"><i class="fas fa-circle"></i> 20240602_2100_DIP_LOC<span class="font-bold">.zip</span></p> -->
                    <p class="single-option"><i class="fas fa-circle"></i> 20240602_2100_AYUN<span class="font-bold">.zip</span></p>
                    <p *ngIf="habilitar_label_regidurias" class="single-option"><i class="fas fa-circle"></i> 20240602_2100_PREP_REG<span class="font-bold">.zip</span></p>
                </div>
                <div class="mobile-parrafo">
                    Cada una de ellas contiene tres tipos de <br>
                    archivos:los resultados y el catálogo de <br>
                    candidaturas ambos en formato <span class="font-bold">csv</span>, por <br>
                    último, el archivo con la descripción de <br>
                    las variables en formato  <span class="font-bold">.txt</span>.
                </div>
            </div>
            <div class="col-12 col-xl-7 p-l">
                <img *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura') && habilitar_label_regidurias" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos.png" alt="">
                <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura') && habilitar_label_regidurias" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos-nogob.png" alt="">
                <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura') && !habilitar_label_regidurias" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos-noreg.png" alt="">
            </div>
            <div class="col-12 p-l">
                
                <div class="padding-b-10 mobile-parrafo">
                    <p class="font-bold">Archivos de resultados:</p>
                </div>
                <div class="padding-b-20 mobile-parrafo">
                    <p *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="single-option"><i class="fas fa-circle"></i> GUB_2024<span class="font-bold">.csv</span></p>
                    <!-- <p class="single-option"><i class="fas fa-circle"></i> DIP_LOC_2024<span class="font-bold">.csv</span></p> -->
                    <p class="single-option"><i class="fas fa-circle"></i> AYUN_2024<span class="font-bold">.csv</span></p>
                    <p *ngIf="habilitar_label_regidurias" class="single-option"><i class="fas fa-circle"></i> REG_2024<span class="font-bold">.csv</span></p>
                </div>
                <div class="padding-b-30 mobile-parrafo">
                    Contienen los resultados de la votación por acta a nivel
                    distrital o municipal. Muestran el número de votos recibidos por <br>
                    cada uno de los Partidos Políticos, combinaciones de <br>
                    coalición, Candidaturas Independientes, candidaturas <br>
                    no regristradas y votos nulos.
                </div>
                <div class="padding-b-10 mobile-parrafo">
                    <p class="font-bold">Catálogos de candidaturas:</p>
                </div>
                <div class="padding-b-20 mobile-parrafo">
                    <p *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="single-option"><i class="fas fa-circle"></i> GUB_CANDIDATURAS_2024<span class="font-bold">.csv</span></p>
                    <!-- <p class="single-option"><i class="fas fa-circle"></i> DIP_LOC_CANDIDATURAS_2024<span class="font-bold">.csv</span></p> -->
                    <p class="single-option"><i class="fas fa-circle"></i> AYUN_CANDIDATURAS_2024<span class="font-bold">.csv</span></p>
                    <p *ngIf="habilitar_label_regidurias" class="single-option"><i class="fas fa-circle"></i> REG_CANDIDATURAS_2024<span class="font-bold">.csv</span></p>
                </div>
                <div class="padding-b-30 mobile-parrafo">
                    Estos documentos contienen el listado de <br>
                    candidaturas por Partido Político y Candidaturas <br>
                    Independientes que participan en las elecciones locales en <br>
                    cada uno de los cargos.
                </div>
                <div class="padding-b-10 mobile-parrafo">
                    <p class="font-bold">Descripción de variables:</p>
                </div>
                <div class="padding-b-20 mobile-parrafo">
                    <p class="single-option"><i class="fas fa-circle"></i> <span class="font-bold">LEEME.txt</span></p>
                </div>
                <div class="padding-b-60 padding-l-50 mobile-parrafo">
                    Describe a detalle cada uno de los campos que <br>
                    forman los archivos de resultados y candidaturas
                </div>
            </div>
            <div class="col-12 p-l nota">
                <p>*Nota: Recuerda, al realizar la descarga, el nombre del archivo <span class="font-bold">.zip</span> se complementará con la <span class="font-bold">fecha</span>, comenzando por el <span class="font-bold">año</span>, <span class="font-bold">mes</span>, y <span class="font-bold">día</span>, así como la hora <br>
                respecto al <span class="font-bold">último corte</span>, conservando siempre esta estructura: AAAAMMDD_HHMM_PREP.zip</p>
            </div>
        </div>
    </div>

    <!-- Descargar -->
    <div class="container-fluid py-5 descargar" id="descargar">
        <div class="row">
            <div class="col-12 p-l">
                <div class="subtitulo padding-b-40">
                    - Descargar -
                </div>
            </div>
            <div class="col-12 p-l-2 padding-b-20">
                <div class="row">
                    <div class="col-12 col-lg-3">
                        <div class="item dis-flex align-s">
                            <div class="numero-descarga dis-flex justify-s padding-r-10 font-bold">
                                1
                            </div>
                            <div class="contenido dis-flex flex-col align-s fs-16">
                                <span class="font-bold">Descarga</span> Haz clic en el botón Base <br> de datos​ para iniciar la <br> descarga del archivo comprimido.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3">
                        <div class="item dis-flex align-s">
                            <div class="numero-descarga dis-flex justify-s padding-r-10 font-bold">
                                2
                            </div>
                            <div class="contenido dis-flex flex-col align-s fs-16">
                                <span class="font-bold">Localiza</span> Encuentra el archivo en<br> la carpeta de descargas.
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                    </div>
                    <!-- <div class="col-12 col-lg-3">
                        <div class="item dis-flex align-s">
                            <div class="numero-descarga dis-flex justify-s padding-r-10 font-bold">
                                3
                            </div>
                            <div class="contenido dis-flex flex-col align-s fs-16">
                                <span class="font-bold">Utiliza los comandos para localizar</span> Windows: CTRL + J<br> Mac: Alt + Cmd + L
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                    </div> -->
                    <div class="col-12 col-lg-2">
                        <div class="item dis-flex align-s">
                            <div class="numero-descarga dis-flex justify-s padding-r-10 font-bold">
                                3
                            </div>
                            <div class="contenido dis-flex flex-col align-s fs-16">
                                <span class="font-bold">Selecciona</span> el archivo, haciendo clic sobre él
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-l-2">
                <img class="img-descargar" src="./assets/img/basededatos/descargar.png" alt="descargar">
            </div>
        </div>
    </div>


    <!-- Descomprimir -->
    <div class="container-fluid {{ !themeService.isDarkTheme() ? 'bgAzul txBlanco' : 'bgWhite'}} py-5 descomprimir" id="descomprimir">
        <div class="row">
            <div class="col-12 p-l">
                <div class="subtitulo padding-b-40">
                    - Descomprimir -
                </div>
            </div>
            <div class="col-12 padding-b-40 p-l-2">
                <div class="row">
                    <div class="col-12 col-lg-3 mobile-parrafo fs-14">
                        <span class="numero-desomprimir">1</span>. Sobre el archivo seleccionado, da clic derecho en <span class="font-bold"> extraer aquí</span>. <br> <br>

                        En el caso del sistema operativo MacOS, sólo haz doble clic sobre el archivo para descomprimir.
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-lila.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-2 mobile-parrafo fs-14">
                        Se abrirá una ventana mostrando el proceso de extracción, los archivos automáticamente te aparecerán en la carpeta de descargas.
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-lila.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-2 mobile-parrafo fs-14">
                        <span class="numero-desomprimir">2</span>. Otra forma es dando <span class="font-bold">clic derecho</span> en el archivo, en el menú que se despliega busca la opción <span class="font-bold">extraer ficheros</span>.
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-lila.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-2 mobile-parrafo fs-14">
                        Puedes <span class="font-bold">seleccionar una carpeta </span> existente o crear una nueva para organizar el contenido descomprimido. Los archivos aparecerán en la carpeta indicada.
                    </div>
                </div>
            </div>
            <div class="p-l-2 padding-b-20">
                <img class="img-descomprimir" src="./assets/img/basededatos/descomprimir.png" alt="descomprimir">
            </div>
            <div class="col-12 text-center mobile-parrafo fs-14">
                Nota: Los sistemas operativos tienen herramientas integradas para la descompresión de archivos,<br>
                también puedes utilizar Winrar o 7-Zip en Windows y RAR en MacOS; (Winzip no funciona)
            </div>
        </div>
    </div>


    <!-- Abrir -->
    <div class="container-fluid py-5 abrir" id="abrir">
        <div class="row">
            <div class="col-12 p-l">
                <div class="subtitulo padding-b-40">
                    - Abrir -
                </div>
            </div>
            <div class="col-12 padding-b-60 p-l-2">
                <div class="row">
                    <div class="col-12 col-lg-3 mobile-parrafo fs-14">
                        <span class="font-bold">Da doble clic</span> sobre el archivo que quieras abrir.
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3 mobile-parrafo fs-14">
                        <span class="font-bold">Los archivos. csv</span> <br> Contienen información organizada en filas y columnas. <br>
                        Puedes visualizar y trabajar con estos archivos en programas de hojas de cálculo como Excel, Access, Calc Open Office, Smartsheet, entre otros.
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3 mobile-parrafo fs-14">
                        <span class="font-bold"> Archivo leeme.txt</span><br> Al hacer doble clic o seleccionar abrirlo, en el menú se abrirá la aplicación según el sistema operativo: Bloc de notas en Windows o Notas en Mac.​
                    </div>
                </div>
            </div>
            <div class="p-l-2">
                <div class="row">
                    <div class="col-12 ">
                        <img *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="img-abrir" src="./assets/img/basededatos/abrir.png" alt="abrir">
                        <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura')" class="img-abrir" src="./assets/img/basededatos/abrir-nogob.png" alt="abrir">

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Consulta -->
    <!-- <div class="container-fluid {{ !themeService.isDarkTheme() ? 'bgRosa txBlanco consulta' : 'bgWhite consulta'}} py-5" id="formato-celdas">
        <div class="row">
            <div class="col-12">
                <div class="text-center titulo pading-b-10">
                    Consulta
                </div>
            </div>
            <div class="col-12 p-l">
                <div class="subtitulo padding-b-20">
                    - Formato de celdas -
                </div>
                <div class="padding-b-40 mobile-parrafo">
                    Para una lectura correcta de las fechas y horas de <br> corte, cambia el formato de celdas de las siguientes <br> columnas a dd/mm/aaaa hh:mm
                </div>
                <div class="mobile-parrafo">
                    <p>
                        1. Selecciona las columnas​
                    </p>
                    <p>
                        2. Da clic derecho en el mouse​
                    </p>
                    <p id="interpretacion-base-de-datos">
                        3. Selecciona “Formato de celdas”​
                    </p>
                    <p>
                        4. Elige el formato<br> “dd/mm/aaaa hh:mm” y <span class="font-bold">Acepta​</span>
                    </p>
                </div>
            </div>
        </div>
    </div> -->

    <!-- Interpretación -->
    <div class="container-fluid {{ !themeService.isDarkTheme() ? 'bgRosa' : 'bgWhite txBlanco'}} py-5 interpretacion" id="interpretacion-base-de-datos">
        <div class="row">
            <div class="col-12">
                <div class="text-center titulo padding-b-40">
                    Consulta de datos
                </div>
            </div>
            <div class="col-12 p-l">
                <div class="subtitulo">
                    - Estructura de los datos -
                </div>
            </div>
            <div class="col-12 col-md-8 p-l">
                <div class="padding-40 padding-t-20 padding-b-20 mobile-parrafo brackets">
                    <div class="bracket-content">
                        Si deseas una revisión detallada de las variables de la Base de Datos, puedes <u>descargar el Manual de Interpretación de la Base de Datos PREP,</u> actualizado en junio de 2024.
                    </div>
                </div>
            </div>
            <div class="col-12 p-l">
                <div class="padding-b-20 mobile-parrafo">
                    Los elementos que conforman el archivo de la Base de Datos son:
                </div>
                <div>
                    <div class="row custom-filas">
                        <div class="col-12 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 1</div>
                            <div class="fila mobile-parrafo">Tipo de elección. Ya sea {{ existeGobernatura ? 'Gubernatura, ' : ''}} {{ (existeGobernatura && (existeDiputaciones && !existeAyuntamientos) || (existeAyuntamientos && !existeDiputaciones)) ? 'o' :'' }} {{existeDiputaciones ? 'Diputaciones' : ''}} {{( (existeGobernatura || existeDiputaciones) && existeAyuntamientos) ? 'o' : ''}} {{existeAyuntamientos ? 'Ayuntamientos' : ''}}.</div>
                        </div>
                        <div class="col-12 padding-b-20">
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <div class="fila-titulo font-bold">
                                        Fila 2
                                    </div>
                                    <div class="fila mobile-parrafo">
                                        <span class="font-bold">Fecha y hora del corte de información</span> con el formato <span class="font-bold">DD/MM/AAAA HH:MM.</span>
                                        <!-- <br> --> Se especifica la hora en formato de 24 horas, Tiempo del estado de {{config.estado}}.
                                        <!-- <div class="px11 my-2 px-2 py-3 bordes-laterales">
                                            <div class="supIzq"></div>
                                            <div class="supDer"></div>
                                            <div class="infIzq"></div>
                                            <div class="infDer"></div>
                                            <p class="p-0 m-0">
                                                Si deseas una revisión detallada de las variables de la Base de Datos descarga el <span class="underline">Manual Interpretación de la Base de Datos PREP, junio 2023.</span>
                                            </p>
                                        </div> -->
                                    </div>
                                </div>
                                <div class="col-12 col-lg-5">
                                    <img *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" class="img-fila2" src="./assets/img/basededatos/fila2.png" alt="fila2">
                                    <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura')" class="img-fila2" src="./assets/img/basededatos/fila2-nogob.png" alt="fila2">
                                </div>
                            </div>
                        </div>
                        <div class="col-12 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 3</div>
                            <div class="fila mobile-parrafo">
                                Nombre de las variables de las columnas de la Base de Datos:
                            </div>
                        </div>
                        <div class="col-12 padding-b-20">
                            <div class="row">
                                <div class="col-12 col-lg-7" style="padding-top: 20px;">
                                    <img class="img-fila4" src="./assets/img/basededatos/fila4.svg" alt="fila4">
                                    <p class="img-description">Conoce más sobre estos términos y su significado en el <u>Centro de Ayuda</u></p>
                                </div>
                                <div class="col-12 col-lg-1 d-none d-lg-block">
                                    <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                                </div>
                                <div class="col-12 col-lg-4 mobile-parrafo font-bold">
                                    <ul>
                                        <li>Actas esperadas​</li>
                                        <li>Actas registradas</li>
                                        <li>​Actas fuera de catálogo​</li>
                                        <li>​Actas capturadas</li>
                                        <li>Porcentaje de actas capturadas</li>
                                        <li>Actas contabilizadas</li>
                                        <li>Porcentaje de actas contabilizadas</li>
                                        <li>Porcentaje de inconsistencias en Actas no contabilizadas</li>
                                        <li>Lista Nominal de las Casillas con actas contabilizadas</li>
                                        <li *ngIf="!config?.hide_especiales">​Total de votos con Casillas Especiales</li>
                                        <li *ngIf="!config?.hide_especiales">​Total de votos sin Casillas Especiales​</li>
                                        <li>Porcentaje de Participación Ciudadana</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 4</div>
                            <div class="fila mobile-parrafo">
                                Contenido de las variables del resumen de la Base de Datos correspondientes a la fila 3.
                            </div>
                        </div>
                        <div class="col-12 col-lg-7 padding-b-20">
                            <div class="fila-titulo font-bold">Fila 5</div>
                            <div class="fila mobile-parrafo">
                                Vacía para separar las variables de los datos de las Casillas.
                            </div>
                        </div>

                        <div class="col-12 padding-b-20">
                            <div class="row">
                                <div class="col-12 padding-b-40">
                                    <div class="fila-titulo font-bold ">Fila 6</div>
                                    <div class="fila mobile-parrafo">
                                        Indica las variables de los resultados de votación, las cuales se pueden agrupar en​:
                                    </div>
                                </div>
                                <div class="col-12 col-lg-7">
                                    <img class="img-fila6" src="./assets/img/basededatos/fila6.svg" alt="fila6">
                                </div>
                                <div class="col-12 col-lg-1 d-none d-lg-block">
                                    <img class="img-descargar" src="./assets/img/basededatos/flecha-violeta.svg" alt="flecha">
                                </div>
                                <div class="col-12 col-lg-4 mobile-parrafo font-bold">
                                    <ul>
                                        <li>Clave Casilla</li>
                                        <li>Clave acta</li>
                                        <li>ID Entidad</li>
                                        <li>Entidad</li>
                                        <li>ID Distrito Federal</li>
                                        <li>Distrito Federal</li>
                                        <li>Sección</li>
                                        <li>ID Casilla</li>
                                        <li>Tipo Casilla</li>
                                        <li>Ext contigua</li>
                                        <li>Ubicación de la Casilla</li>
                                        <li>Totales derivados de la votación</li>
                                        <li>Resultados de la votación</li>
                                        <li>Estatus, traslado y seguridad de las actas</li>
                                        <li>Procesamiento de las actas</li>
                                        <li>Proceso de digitalización</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="fila-titulo font-bold">Fila 7</div>
                            <div class="fila mobile-parrafo">
                                A partir de esta fila se indican los datos correspondientes a cada Acta.
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="row">
                                <div class="col-12 col-lg-7">
                                    <img class="img-fila7" src="./assets/img/basededatos/fila7.svg" alt="fila7">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid py-5 autenticidad {{ !themeService.isDarkTheme() ? 'bgAzul txBlanco' : 'bgWhite'}}" id="autenticidad">
        <div class="row">
            <div class="col-12">
                <div class="subtitulo padding-b-20">
                    - Autenticidad -
                </div>
                <div class="padding-b-80 mobile-parrafo">
                    Para validar la autenticidad de la imagen del Acta de tu casilla, puedes utilizar un software lector de código único de imagen de la siguiente forma.​​
                </div>
            </div>
            <div class="col-12 p-l-2 padding-b-20">
                <div class="row">
                    <div class="col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Código HASH ​
                        </p>
                        <p>
                            &#8226; Es una serie de caracteres únicos asociados al archivo de la imagen digitalizada del Acta de Escrutinio y Cómputo (AEC). ​
                        </p>
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-blanca.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Verifica​​
                        </p>
                        <p>
                            &#8226; Busca en internet algún lector de códigos para comprobar si la imagen del AEC fue manipulada con editores de imágenes, o si se intentó alterar el archivo y la legitimidad de la información.
                        </p>
                        <!-- <p>
                            &#8226; Si fue manipulada la imagen del AEC con algún editor de imágenes.
                        </p>
                        <p>
                            ​&#8226; Intento de alteración del archivo.
                        </p>
                        <p>
                            &#8226;​ Legitimidad de las imágenes y de la información.​
                        </p> -->
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-blanca.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Valida
                        </p>
                        <p>
                            &#8226; Una vez localizado o descargado el lector de código de integridad, selecciona la opción de lectura HASH 256, ya que es el utilizado por el PREP para validar que el archivo no fue alterado.
                        </p>
                    </div>
                </div>
            </div>
            <div class="offset-3 col-6 padding-b-20">
                <img class="img-descargar" src="./assets/img/basededatos/autenticidad-1.gif" alt="autenticidad-1">
            </div>
            <div class="col-12 p-l-2 padding-b-40">
                <div class="row">
                    <div class="col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Ubica​ el Acta
                        </p>
                        <p>
                            &#8226; Encuentra y descarga el acta de la Casilla que deseas verificar desde el PREP a tu computadora.
                        </p>
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-blanca.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Genera el Código HASH​​​
                        </p>
                        <p>
                            &#8226; Abre el lector del código de integridad HASH 256 de tu preferencia y sube el archivo de la <u>imagen del Acta</u>.
                        </p>
                        <p>
                            ​&#8226; ​Sigue la secuencia: File-Select File (Archivo-Seleccionar Archivo).​
                        </p>
                        <p>
                            ​&#8226; ​Selecciona la opción SHA256. ​
                        </p>
                        <p>
                            &#8226;​ Elige el archivo y presiona abrir.​
                        </p>
                    </div>
                    <div class="col-12 col-lg-1 d-none d-lg-block">
                        <img class="img-descargar" src="./assets/img/basededatos/flecha-blanca.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Copia y pega​
                        </p>
                        <p>
                            &#8226; Copia y pega el código que arroja el lector de código SHA y pégalo en la Base de Datos del PREP al lado de la columna Código_integridad.​
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 padding-b-40">
                <div class="row">
                    <div class="col-12 col-lg-6 text-center">
                        <img class="img-autenticidad-2" src="./assets/img/basededatos/autenticidad-2.svg" alt="autenticidad-2">
                    </div>
                    <div class="col-12 col-lg-6 text-center">
                        <img class="img-autenticidad-3" src="./assets/img/basededatos/autenticidad-3.svg" alt="autenticidad-3">
                    </div>
                </div>
            </div>
            <div class="col-12 padding-b-40">
                <div class="row">
                    <div class="offset-2 col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Compara
                        </p>
                        <p>
                            &#8226; Compara el código de la <u>imagen del acta</u> con el proporcionado por el lector de código HASH 256.
                        </p>
                        <p>
                            &#8226; Asegúrate de que todos los caracteres coincidan, independientemente de la mayúsculas o minúsculas.
                        </p>
                    </div>
                    <div class="col-12 col-lg-2 text-center d-none d-lg-block">
                        <img class="img-flecha-blanca-sm" src="./assets/img/basededatos/flecha-blanca.svg" alt="flecha">
                    </div>
                    <div class="col-12 col-lg-3 mobile-parrafo">
                        <p class="font-bold">
                            Confirma que no hay alteraciones
                        </p>
                        <p>
                            &#8226; A través del Código HASH 256 podrás identificar fácilmente si la imagen del acta fue manipulada con algún software de edición de imágenes.​
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 padding-b-80">
                <div class="row">
                    <div class="col-12 col-lg-6 text-center">
                        <img class="img-autenticidad-4" src="./assets/img/basededatos/autenticidad-4.svg" alt="autenticidad-4">
                    </div>
                    <div class="col-12 col-lg-6 text-center">
                        <img class="img-autenticidad-5" src="./assets/img/basededatos/autenticidad-5.svg" alt="autenticidad-5">
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div class="row">
                    <p class="padding-40 padding-b-20">Este proceso asegura que la imagen del acta de tu Casilla no haya sido modificada y garantiza la autenticidad de la información contenida en ella. Sigue estos pasos para asegurarte de la integridad de los resultados electorales.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="container-fluid py-5 autenticidad p-l" *ngIf="_obtenerDatosService.hasCatalogos()">
        <div class="row">
            <div class="col-12">
                <div class="subtitulo padding-b-40">
                    - Catálogo de secciones, distritos y municipios -
                </div>
            </div>
            <div class="col-12 col-lg-7">
                <div class="padding-t-60 mobile-parrafo">
                    Este Catálogo muestra la lista aprobada de casillas del día previo a la Jornada Electoral, con información actualizada hasta las 20:00. Es importante destacar que no se realizarán actualizaciones posteriores a ese corte de información.
                </div>
            </div>
            <div class="col-12 col-lg-5" >
                <img src="./assets/img/basededatos/catalogo.png" alt="">
            </div>
        </div>
    </div>

    <div class="contenido container-fluid {{ !themeService.isDarkTheme() ? 'bgAzul txBlanco' : 'bgWhite'}} py-5" *ngIf="_obtenerDatosService.hasCatalogos()">
        <div class="row justify-content-center p-l-2">
            <div class="col-12 padding-b-40">
                <div class="subtitulo pading-b-10">
                    - Descripción del contenido de los archivos -
                </div>
            </div>
            <div class="col-12 col-xl-6">
                <div class="padding-b-30 mobile-parrafo">
                    Dentro de este archivo <b>.zip</b>, encontrarás dos documentos:
                </div>
                <div class="padding-b-20 mobile-parrafo">
                    <p *ngIf="existeGobernatura" class="single-option"><i class="fas fa-circle"></i> <span class="font-bold">GUB.csv</span></p>
                    <p *ngIf="!existeGobernatura" class="single-option"><i class="fas fa-circle"></i> <span class="font-bold">DIP.csv</span></p>
                </div>
                <div class="padding-b-60 padding-l-50 mobile-parrafo fs-09em">
                    <p>Corresponde a los datos de identificación de las casillas aprobadas, extraídos de la base de datos; cada línea corresponde a una casilla, están separados por comas. En él se muestra la clave de cada silla, junto con la información clave de su ubicación. Incluye datos de la entidad, el distrito local, el municipio y la sección correspondiente.</p>
                    
                    <p>Los datos son los siguientes:</p>
                    
                    <p>CLAVE_CASILLA | CLAVE_ACTA | ID_ENTIDAD | ENTIDAD | ID_DISTRITO_LOCAL | DISTRITO_LOCAL | SECCION | ID_CASILLA | TIPO_CASILLA | EXT_CONTIGUA | UBICACION_CASILLA | LISTA_NOMINAL</p>
                </div>

                <div class="padding-b-20 mobile-parrafo">
                    <p class="single-option"><i class="fas fa-circle"></i> <span class="font-bold">LEEME.txt</span></p>
                </div>
                <div class="padding-b-60 padding-l-50 mobile-parrafo fs-09em">
                    <p>Describe a detalle cada uno de los campos que forman el archivo del catálogo.</p>
                </div>
            </div>
            <div class="col-12 col-xl-6 p-l">
                <img *ngIf="globalService.arrContiendasActivasStr.includes('gubernatura')" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos2.png" alt="">
                <img *ngIf="!globalService.arrContiendasActivasStr.includes('gubernatura')" style="width: 100%;" src="./assets/img/basededatos/carpetaarchivos2-nogob.png" alt="">
            </div>
            <div class="col-12 fs-09em">
                <p>Puedes seguir las mismas instrucciones de descarga, descompresión, y apertura del archivo que para la base de datos. Si no las recuerdas, <u>regresa a ellas</u>.</p>
                <p>Este archivo se convierte en una herramienta para realizar análisis cruzados entre datos locales y federales, lo que permite una compresión más completa de la ubicación y contexto de tu casilla en el contexto político y geográfico.</p>
            </div>

        </div>
        <p *ngIf="_obtenerDatosService.hasCatalogos()" class="text-center padding-t-40">Descarga el archivo .zip del <u (click)="_obtenerDatosService.downloadBaseDatos('catalogos')">Catálogo de secciones, distritos y municipios.</u></p>
    </div>


    <!--  <app-base-datos-definicion></app-base-datos-definicion>
    <app-base-datos-carpeta-archivos></app-base-datos-carpeta-archivos>
    <app-base-datos-consulta></app-base-datos-consulta> -->
</div>

<div class="base-datos d-block d-md-block d-xl-none" style="margin-top: -60px;">
    <div class="movil-bd-title">
        <h2>Base de Datos </h2>

        <p class="movil-guide-label">Guía de descarga de archivos</p>
    </div>

    <div class="movil-card" style="margin-top: -50px;">
        <img height="80" width="80" src="../../../../../assets/img/basededatos/ic-books-db.svg"/>
        <div class="subtitulo padding-b-50 p-l">
            Base de Datos PREP
        </div>
        <div style="text-align: justify; margin-top: 16px;">
            La Base de Datos se refiere al conjunto de información perteneciente al Programa de Resultados Electorales Preliminares, ordenada de forma sistemática para su descarga y análisis.​ Es actualizada conforme al último corte. Permite realizar distintas operaciones ya que incluye datos numéricos, alfanuméricos y cronológicos. En este documento exponemos la propuesta de estructura y copies para el apartado de base de datos en el sitio del PREP.
        </div>

        <div class="menu padding-b-20 px-2 align-center">
            <button (click)="_obtenerDatosService.downloadBaseDatos()" type="button" class="btn btn-blanco2">Descargar  <i class="fa fa-download"></i></button>
        </div>

        <div style="align-items: center; margin-left: 24px;">
            <p class="movil-db-seccion"><span class="fa fa-angle-right"></span>&nbsp;&nbsp;<span [routerLink]="['/base-de-datos/definicion']" style="text-decoration: underline;">Definición</span></p>
            <p class="movil-db-seccion"><span class="fa fa-angle-right"></span>&nbsp;&nbsp;<span [routerLink]="['/base-de-datos/carpeta']" style="text-decoration: underline;">Carpeta de archivos</span></p>
            <p class="movil-db-seccion"><span class="fa fa-angle-right"></span>&nbsp;&nbsp;<span [routerLink]="['/base-de-datos/consulta']" style="text-decoration: underline;">Consulta</span></p>
        </div>
    </div>


    <div class="movil-card" style="margin-top: 30px;" *ngIf="_obtenerDatosService.hasCatalogos()">
        <img height="80" width="80" src="../../../../../assets/img/basededatos/ic-folder-db.svg"/>
        <div class="subtitulo padding-b-50 p-l">
            Catálogo de secciones, distritos y municipios
        </div>
        <div style="text-align: justify; margin-top: 16px;">
            Este Catálogo muestra la lista aprobada de casillas del día previo a la Jornada Electoral, con información actualizada hasta las 20:00. Es importante destacar que no se realizarán actualizaciones posteriores a ese corte de información.
        </div>

        <div class="menu padding-b-20 px-2 align-center">
            <button (click)="_obtenerDatosService.downloadBaseDatos('catalogos')" type="button" class="btn btn-blanco2">Descargar  <i class="fa fa-download"></i></button>
        </div>

        <div style="align-items: center; margin-left: 24px;">
            <p class="movil-db-seccion"><span class="fa fa-angle-right"></span>&nbsp;&nbsp;<span [routerLink]="['/base-de-datos/catalogos']" style="text-decoration: underline;">Descripción del contenido de los archivos</span></p>
        </div>
    </div>

    <div style="width: 100%; height: 30px;">

    </div>
</div>